import {get} from 'lodash';
import {State} from 'redux/reducer';
import {loginReducerKey} from './types';
import {enums} from 'types/enums';
import {createSelector} from 'reselect';
import {AdminResourceTypeUnion} from 'types/diplomat/settings/adminroles/AdminResourceType';

const getResources = (state: State) => state[loginReducerKey].data?.resources || [];

const getResourcesMap = createSelector(getResources, (resources) => {
   const map = {} as Record<AdminResourceTypeUnion, boolean>;

   resources.forEach((res) => (map[res] = true));
   return map;
});

const isShowPasswordPermit = createSelector(getResources, (resources) =>
   resources?.some((res) => res === enums.AdminResourceType.enum.PASSWORDS)
);

// const adminRoleIds = (state: State) => state[loginReducerKey].data?.user?.adminRoleIds;
// const adminRoles = (state: State) => state[settingsReducerKey].adminRoles;

const isAdmin = () => true;
// (createSelector(adminRoles, adminRoleIds, (adminRoles, roleIds) => {
//    return roleIds.some((id) => adminRoles.find((ar) => ar.id === id && ar.name === ADMINISTRATOR));
// }));

const isReviewer = () => false;
// createSelector(adminRoles, adminRoleIds, (adminRoles, roleIds) => {
//    return adminRoles.some((ar) => ar.id === roleIds[0] && ar.name === REVIEWER);
// });

export default {
   getLoginErrorMessage: (state: State) => {
      return get(state, [loginReducerKey, 'error', 'statusText']);
   },
   isAuthenticated: (state: State) => state[loginReducerKey].isAuthenticated,
   userId: (state: State) => state[loginReducerKey].data?.user?.id,
   userName: (state: State) => state[loginReducerKey].data?.user?.userName,
   hasUserName: (state: State) => !!state[loginReducerKey].data?.user?.userName,
   contactName: (state: State) => state[loginReducerKey].data?.user?.contactName,

   isAdmin,
   isReviewer,
   getApplVersion: (state: State) => state[loginReducerKey].data?.applVersion,
   getServerBuildID: (state: State) => state[loginReducerKey].data?.serverBuildID,
   getRootFolderName: (state: State) =>
      `${state[loginReducerKey].data?.serverDisplayName} (${state[loginReducerKey].data?.applVersion} Build ${state[loginReducerKey].data?.serverBuildID})`,
   machineName: (state: State) => state[loginReducerKey].data?.serverDisplayName,
   lastPasswordUpdate: (state: State) => state[loginReducerKey].data?.user?.lastPasswordUpdate,
   isShowPasswordPermit,
   getResources,
   getResourcesMap,
   itemsPermissions: (state: State) => state[loginReducerKey].itemsPermissions,
};
